// Common JS - loaded on all pages
import headerBar from './headerBar';
import handleMobileMenu from './mobileMenu';
import handleBodyClasses from './handleBodyClasses';

export default {
	/**
	 * Runs first, before any JS
	 */
	init: () => {
		headerBar();
		handleMobileMenu();
		handleBodyClasses();

		// const { fn: { requireJs }, lazyJs } = am2;

		// requireJs(lazyJs, ['sweetalert'], () => {
		// 	console.log('Swall call #1');
		// });
	},
	/**
	 * Runs last, after specific routes but before lazy loaded JS
	 */
	complete: () => {
		// const { fn: { requireJs }, lazyJs } = am2;

		// requireJs(lazyJs, ['sweetalert'], () => {
		// 	console.log('Swall call #2: Again, however it should load one instance of assets!');
		// });
	},
	/**
	 * LazyLoaded
	 */
	// lazy: {
	// 	id: ['tippy'],
	// 	condition() {
	// 		console.log('You will not see the Popper JS being loaded because condition is not met, eg: no tooltips on the page!');
	// 		// Must return a boolean value.
	// 		return false;
	// 	},
	// 	callback() {
	// 		console.log('Popper JS: this should be appear last on the console - if condition is met!');
	// 	}
	// }
};
